var map = {
	"./cascata_01.jpg": "632a",
	"./cascata_02.jpg": "2823",
	"./entrada_01.jpg": "5269",
	"./entrada_02.jpg": "bc63",
	"./escadaria_01.jpg": "0cd5",
	"./escadaria_02.jpg": "1023",
	"./feteira_01.jpg": "9db1",
	"./int1_ent_cas_01.jpg": "7dc1",
	"./int2_cas_fet_01.jpg": "9c2a",
	"./int3_fet_rui_01.jpg": "280b",
	"./int4_rui_lag_01.jpg": "775f",
	"./int4_rui_lag_02.jpg": "aebd",
	"./int6_jar_ros_01.jpg": "cfce",
	"./int7_ros_rel_01.jpg": "d76e",
	"./int7_ros_rel_02.jpg": "da9b",
	"./int8_rel_esc_01.jpg": "e909",
	"./int8_rel_esc_02.jpg": "78f5",
	"./int9_esc_pal_01.jpg": "6008",
	"./jardimmx_01.jpg": "c734",
	"./jardimmx_02.jpg": "d57b",
	"./lagos_01.jpg": "a020",
	"./lagos_02.jpg": "e0e6",
	"./palacio_01.jpg": "0913",
	"./palacio_02.jpg": "3d5a",
	"./palacio_03.jpg": "d866",
	"./palacio_04.jpg": "15fe",
	"./relvado_01.jpg": "4e9d",
	"./relvado_02.jpg": "3bf2",
	"./roseiral_01.jpg": "cbe1",
	"./roseiral_02.jpg": "f2fd",
	"./ruina_01.jpg": "9620"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";